export const SEGMENT_DETAILS = {
  TAB_KEYS: {
    SUMMARY: 'summary',
    SEGMENT_RULES: 'segment_rules',
    SAMPLE_CUSTOMERS: 'sample_customers',
  },
} as const

export type SegmentTab =
  typeof SEGMENT_DETAILS.TAB_KEYS[keyof typeof SEGMENT_DETAILS.TAB_KEYS]
